<template>
  <div>
    <Form
      ref="newTaskData"
      :model="newTaskData"
      :rules="ruleValidate"
      label-position="top"
    >
      <FormItem
        label="任务类型"
        prop="taskitemType"
        v-if="taskitemTypeArray.length>1"
      >
        <Select
          v-model="newTaskData.taskitemType"
          placeholder="任务类型"
        >
          <Option
            v-for="item in taskitemTypeArray"
            :key="'taskType_'+item.value"
            :value="item.value"
          >{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem
        label="作业日期"
        prop="actionDate"
      >
        <DatePicker
          placeholder="选择作业日期"
          v-model="newTaskData.actionDate"
          type="date"
          style="width:100%"
          :editable="false"
          :clearable="false"
          @on-change="changeActionDate"
        ></DatePicker>
      </FormItem>
      <slot name="extra">

      </slot>
      <FormItem label="备注">
        <Input
          type="textarea"
          :rows="3"
          v-model.trim="newTaskData.remarks"
          placeholder="备注"
        />
      </FormItem>
      <FormItem>
        <div class="text-right">
          <Button
            type="primary"
            :loading="submitLoading"
            :disabled="selectedResourceIdArray.length===0"
            @click="handleSubmit"
          >确认设置</Button>
        </div>

      </FormItem>
    </Form>
  </div>
</template>

<script>
import { getTaskitemTypeList, setTaskitem, updateTaskitem, setStationTaskitem } from '@/api/msp/demandV3'

export default {
  props: {
    opreateType: {
      type: Number,
      default: 1
    },
    taskType: {
      type: Number,
      required: true
    },
    taskId: {
      type: Number,
      required: true
    },
    dataSource: {
      type: Number,
      default: 1
    },
    selectedResourceIdArray: [Array],
    selectedTaskitemIdArray: [Array]
  },
  data () {
    return {
      submitLoading: false,
      taskitemTypeArray: [],
      newTaskData: {
        taskitemType: null,
        actionDate: '',
        deviceIds: '',
        taskId: null,
        extras: '',
        productId: null,
        remarks: ''
      },
      ruleValidate: {
        actionDate: [{ required: true, message: '作业日期不能为空', trigger: 'change' }],
        taskitemType: [{ required: true, type: 'number', message: '请选择任务类型', trigger: 'change' }]
        // name: [{ required: true, type: 'string', message: '请填写任务名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getTaskitemTypeData () {
      getTaskitemTypeList({ tasktype: this.taskType }).then(res => {
        if (res && !res.errcode) {
          this.taskitemTypeArray = res
          if (this.taskitemTypeArray.length > 0) {
            this.newTaskData.taskitemType = this.taskitemTypeArray[0].value
          }
        } else {
          this.taskitemTypeArray = []
        }
      })
    },
    changeActionDate (date) {
      this.newTaskData.actionDate = date
    },
    handleSubmit () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确认信息无误并提交？',
        onOk: () => {
          this.submitLoading = true
          switch (this.taskType) {
            case 8:
              this.handleSetInspectionTask()
              break
            case 9:
              this.handleSetMaintainTask()
              break
            default:
              this.handleSetMaintainTask()
              break
          }
        }
      })
    },
    /**
     * 处理设置维护任务提交
     */
    handleSetMaintainTask () {
      this.handleBtnLoading()
      if (this.opreateType === 1) {
        this.newTaskData.taskId = this.taskId
        this.newTaskData.deviceIds = JSON.stringify(this.selectedResourceIdArray)
        setTaskitem(this.newTaskData).then(res => {
          this.submitLoading = false
          clearTimeout(this.handleBtnLoading())
          if (res && res.errcode === 0) {
            // this.selectedTaskitemIdArray = []
            this.$emit('handleSetSuccess')
            this.$Notice.success({ desc: '操作成功' })
          }
        })
      } else {
        this.newTaskData.taskitemIds = JSON.stringify(this.selectedTaskitemIdArray)
        updateTaskitem(this.newTaskData).then(res => {
          this.submitLoading = false
          clearTimeout(this.handleBtnLoading())
          if (res && res.errcode === 0) {
            // this.selectedResourceIdArray = []
            // this.selectedTaskitemIdArray = []
            // this.$store.commit('set_temp_selected_item', null)
            // this.$store.dispatch('getTaskitemData')
            this.$emit('handleSetSuccess')
            this.$Notice.success({ desc: '操作成功' })
          }
        })
      }
    },
    /**
     * 处理设置巡检任务提交
     */
    handleSetInspectionTask () {
      this.handleBtnLoading()
      if (this.opreateType === 1) {
        this.newTaskData.taskId = this.taskId
        this.newTaskData.stationIds = JSON.stringify(this.selectedResourceIdArray)
        setStationTaskitem(this.newTaskData).then(res => {
          this.submitLoading = false
          clearTimeout(this.handleBtnLoading())
          if (res && res.errcode === 0) {
            // this.selectedResourceIdArray = []
            // this.selectedTaskitemIdArray = []
            // this.$store.commit('set_temp_selected_item', null)
            // this.$store.dispatch('getStationData')
            this.$Notice.success({ desc: '操作成功' })
            this.$emit('handleSetSuccess')
          }
        })
      } else {
        this.newTaskData.taskitemIds = JSON.stringify(this.selectedTaskitemIdArray)
        updateTaskitem(this.newTaskData).then(res => {
          this.submitLoading = false
          clearTimeout(this.handleBtnLoading())
          this.submitLoading = false
          if (res && res.errcode === 0) {
            // this.selectedResourceIdArray = []
            // this.selectedTaskitemIdArray = []
            // this.$store.commit('set_temp_selected_item', null)
            // this.$store.dispatch('getTaskitemData')
            this.$Notice.success({ desc: '操作成功' })
            this.$emit('handleSetSuccess')
          }
        })
      }
    },
    /**
     * 处理按钮加载样式
     */
    handleBtnLoading () {
      setTimeout(() => {
        this.submitLoading = false
      }, 15 * 1000)
    }
  },
  watch: {
    taskId: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.getTaskitemTypeData()
        }
      }
    }
  }
}
</script>
